import React from "react";
import ReactDOM from "react-dom";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const renderTime = ({ remainingTime }) => {
  if (remainingTime === 0) {
    return <div className="timer">Too lale...</div>;
  }

  return (
    <div style={{fontSize:"26px"}}>
      {remainingTime}
    </div>
  );
};

export default function Countdown({
    duration = 10
  }) {
  return (<CountdownCircleTimer
    isPlaying
    duration={duration}
    colors={[["#004777", 0.33], ["#F7B801", 0.33], ["#A30000"]]}
    onComplete={() => [true, 1000]}
    size={100}
    strokeWidth={8}
  >
    {renderTime}
  </CountdownCircleTimer>);
}
